import { createFileRoute } from "@tanstack/react-router";

import { PlayerList } from "@/components/manager/player-list";
import { SetCard } from "@/components/manager/set-card";
import { TeamProgressCard } from "@/components/manager/team-progress-card";
import { mockTeam } from "@/lib/mock/manager-dashboard";

export const Route = createFileRoute("/_plama/plama")({
  head: () => ({ meta: [{ title: "Plama" }] }),
  component: PlamaDashboard,
});

function PlamaDashboard() {
  const team = mockTeam;

  return (
    <div className="mx-auto max-w-lg space-y-3">
      <TeamProgressCard team={team} />

      {team.photoSets.map((set) => (
        <SetCard key={set.id} set={set} players={team.players} />
      ))}

      <PlayerList players={team.players} photoSets={team.photoSets} />
    </div>
  );
}
